import React from 'react';
import ArtworkPreview from './ArtworkPreview';
import ArtworkUploadBox from './ArtworkUploadBox';

const ProductArtworkSection = ({ artworks = [], setName = 'Product artwork' }) => {
    const artworkBySide = artworks.reduce((acc, artwork) => {
        if (artwork?.side) {
            acc[artwork.side] = artwork;
        }
        return acc;
    }, {});

    return (
        <div className="artworkSectionContainer">
            <div className="artworkSetHeader">
                <span className="artworkSetName">{setName}</span>
            </div>

            <div className="artworkGrid">
                {['front', 'back', 'sleeve', 'hood'].map((side, sideIndex) => {
                    const sideArt = artworkBySide?.[side];
                    if (sideArt) {
                        return (
                            <ArtworkPreview
                                key={sideIndex}
                                imageUrl={sideArt.origin_url}
                                thumbnail={sideArt.thumbnail}
                                width={sideArt.width}
                                height={sideArt.height}
                                side={side}
                            />
                        );
                    }

                    return <ArtworkUploadBox key={`disabled-${sideIndex}`} disabled />;
                })}
            </div>
        </div>
    );
};

export default ProductArtworkSection;
